export const timeout = (prom: Promise<any>, ms: number) =>
  Promise.race([prom, new Promise((_r, rej) => setTimeout(rej, ms))]);
